import {
  OnlineOfferAlternative,
  OnlineOfferAlternativesResponseBody,
} from '../api/types/onlineOfferAlternativesTypes';

export type AlternativeChoiceStatus = 'NONE' | 'CHOSEN' | 'PREPARING';

/**
 * The public choice does not say who made it: the seller may have applied another alternative
 * than the customer chose. An applied choice is therefore described as the adviser's work, and
 * only a choice that is not applied yet is described as the customer's own.
 */
export const getAlternativeChoiceStatus = (
  offerAlternatives: Pick<OnlineOfferAlternativesResponseBody, 'customerChoice'>,
  alternative: Pick<OnlineOfferAlternative, 'id' | 'isApplied'>
): AlternativeChoiceStatus => {
  const {customerChoice} = offerAlternatives;
  if (customerChoice?.alternativeId !== alternative.id || !customerChoice.isCurrent) {
    return 'NONE';
  }
  return alternative.isApplied ? 'PREPARING' : 'CHOSEN';
};
